import axios from 'axios';

// Use the proxy path instead of direct API URL
const API_URL = '/api';

export interface Ad {
  id: number;
  title: string;
  description: string;
  category: string;
  target_keywords: string[];
  status: string;
  is_active: boolean;
  ctr: number;
  campaign_id?: number;
  created_at?: string;
  updated_at?: string;
}

export interface AdCreate {
  title: string;
  description: string;
  category: string;
  target_keywords: string[];
  status: string;
  campaign_id?: number;
}

export interface AdUpdate extends Partial<AdCreate> {
  is_active?: boolean;
  ctr?: number;
}

export interface AdVariantRequest {
  product_description: string;
  persona: string;
  tone: string;
  num_variants: number;
}

export interface AdVariant {
  title: string;
  description: string;
  cta: string;
}

export const getAds = async () => axios.get<Ad[]>(`${API_URL}/ads/`).then(res => res.data);
export const createAd = async (data: AdCreate) => axios.post<Ad>(`${API_URL}/ads/`, data).then(res => res.data);
export const updateAd = async (id: number, data: AdUpdate) => axios.put<Ad>(`${API_URL}/ads/${id}`, data).then(res => res.data);
export const deleteAd = async (id: number) => axios.delete(`${API_URL}/ads/${id}`);
export const generateAdVariants = async (payload: AdVariantRequest): Promise<AdVariant[]> => {
  const response = await axios.post(`${API_URL}/ads/generate-variants`, payload);
  return response.data.variants;
}; 